import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1da56b42"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "range-bar"
}, null, -1));
const _hoisted_2 = [_hoisted_1];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: "background-bar",
    style: _normalizeStyle({
      height: `${$props.height}px`
    })
  }, null, 4), _createElementVNode("div", {
    class: "range-box",
    style: _normalizeStyle({
      '--range-bar-color': `${$props.color}`,
      left: `${$options.rangePositionAndWidth.rangePosition}%`,
      width: `${$options.rangePositionAndWidth.rangeWidth}%`
    })
  }, _hoisted_2, 4), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.values, value => {
    return _openBlock(), _createBlock(_resolveDynamicComponent(value.component), {
      color: value.color,
      size: value.value ? value.size : 0,
      style: _normalizeStyle({
        zIndex: value.zIndex ?? 0,
        position: 'absolute',
        left: `${$options.getValuePosition(value.value)}%`
      })
    }, null, 8, ["color", "size", "style"]);
  }), 256))], 64);
}